import { AudioField } from '@/admin/features/activity-editor/extensions/audio';
import { Checkbox } from '@/admin/features/activity-editor/extensions/checkbox';
import { DateField } from '@/admin/features/activity-editor/extensions/date';
import { FileUpload } from '@/admin/features/activity-editor/extensions/file-upload';
import { ImageField } from '@/admin/features/activity-editor/extensions/image';
import { LongAnswer } from '@/admin/features/activity-editor/extensions/long-answer';
import { MultipleChoice } from '@/admin/features/activity-editor/extensions/multiple-choice';
import { ShortAnswer } from '@/admin/features/activity-editor/extensions/short-answer';
import { VideoField } from '@/admin/features/activity-editor/extensions/video';
import { cn } from '@/lib/utils';
import {
	DragHandle,
	HorizontalRule,
	MarkdownExtension,
	Placeholder,
	StarterKit,
	TiptapLink,
	TiptapUnderline,
} from './core';

const horizontalRule = HorizontalRule.configure({
	HTMLAttributes: {
		class: cn('mt-4 mb-6 border-t border-muted-foreground'),
	},
});

const starterKit = StarterKit.configure({
	bulletList: {
		HTMLAttributes: {
			class: cn('list-disc list-outside leading-3'),
		},
	},
	orderedList: {
		HTMLAttributes: {
			class: cn('list-decimal list-outside leading-3'),
		},
	},
	listItem: {
		HTMLAttributes: {
			class: cn('leading-normal'),
		},
	},
	blockquote: {
		HTMLAttributes: {
			class: cn('border-l-4 border-primary'),
		},
	},
	code: {
		HTMLAttributes: {
			class: cn('rounded-md bg-muted  px-1.5 py-1 font-mono font-medium'),
			spellcheck: 'false',
		},
	},
	horizontalRule: false,
	dropcursor: {
		color: '#DBEAFE',
		width: 4,
	},
	gapcursor: false,
});
const tiptapLink = TiptapLink.configure({
	HTMLAttributes: {
		class: cn(
			'text-muted-foreground underline underline-offset-[3px] hover:text-primary transition-colors cursor-pointer',
		),
	},
});
const placeholder = Placeholder.configure({
	showOnlyCurrent: false,
});

const markdownExtension = MarkdownExtension.configure({
	html: true,
	tightLists: true,
	tightListClass: 'tight',
	bulletListMarker: '-',
	linkify: false,
	breaks: false,
	transformPastedText: false,
	transformCopiedText: false,
});

export let dragging = false;

const dragHandle = DragHandle.configure({
	render: () => {
		const element = document.createElement('div');
		element.classList.add('AllCoach-Drag-Handle');
		element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-grip-vertical-icon lucide-grip-vertical"><circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/></svg>`;
		return element;
	},
	onElementDragStart() {
		dragging = true;
	},
	onElementDragEnd() {
		dragging = false;
	},
	computePositionConfig: {
		placement: 'left-start',
	},
});

export const defaultExtensions = [
	starterKit,
	placeholder,
	tiptapLink,
	horizontalRule,
	TiptapUnderline,
	markdownExtension,
	dragHandle,
	LongAnswer,
	ShortAnswer,
	MultipleChoice,
	Checkbox,
	DateField,
	FileUpload,
	ImageField,
	VideoField,
	AudioField,
];
